// 清空数据
export const CHANGELANG = "CHANGELANG";
// 初始化APP
export const INITAPPDATA = "INITAPPDATA";
// 侧边是否打开
export const DRAWEROPEN = "DRAWEROPEN";
// 账户相关
export const ACCOUNTINFO = "ACCOUNTINFO";
// 用户图标修改
export const AVATAREDIT = "AVATAREDIT";
// 用户修改邮箱
export const EMAIL = "EMAIL";
// 用户手机号修改
export const PHONE = "PHONE";
// 云账号绑定成功
export const ACCOUNTACTIVATION = "ACCOUNTACTIVATION";
// 全部应用侧拉是否打开
export const ALLAPPSDRAWEROPEN = "ALLAPPSDRAWEROPEN";
// 获取所有消息
export const SETMESSAGEDATA = "SETMESSAGEDATA";
// 存储知识条目
export const SETKNOWLEDGE = "SETKNOWLEDGE";
// 存储知识权限
export const SETKNOWLEDGERULE = "SETKNOWLEDGERULE";
// 存储最近访问
export const SETRECENT = "SETRECENT";
// 存储知识管理是否具有安装及请求权限
export const SETKNOWLEDGERULEONCE = "SETKNOWLEDGERULEONCE";
// 开启勿扰模式
export const SETDISTURBMODE = "SETDISTURBMODE";
// 错误中心
export const ERROR = "ERROR";
export const SETNEWMSG = 'SETNEWMSG'
//跨组件录制spr
export const ISACCOUNTSETTINGSPR = 'ISACCOUNTSETTINGSPR'
// 背景设置
export const SETBACKGROUNDSTATE = 'SETBACKGROUNDSTATE'
// 字体
export const NCCFONT = 'NCCFONT'
// 主题色设置
export const SETTHEMECOLOR = 'SETTHEMECOLOR'
// /是否点击面包屑
export const BREADCRUMBCLICK = 'BREADCRUMBCLICK'
// 工作台数据
export const SETWORKBENCHDATA = 'SETWORKBENCHDATA'
// 工作台主键
export const SETWORKBENCHID = 'SETWORKBENCHID'
// 联动设置数据
export const SETLINKAGEDATA = 'SETLINKAGEDATA'
// 水印
export const SETWATERMARKINFO = 'SETWATERMARKINFO'